<script setup>
import { RouterView } from "vue-router";
import Snackbar from "@/components/Snackbar.vue";

import { useAlertsStore } from "@/stores/alerts";
import LoadingUserData from "./components/LoadingUserData.vue";
import { useAuthenticationStore } from "./stores/authentication";
import { onMounted } from "vue";
import { watch } from "vue";
import { useSchoolStore } from "./stores/school";
import { useConferenceStore } from "./stores/teacher/conference";
import router from "./router";
import authService from "./services/auth.service";
const alertStore = useAlertsStore();
const authStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const confStore = useConferenceStore();

watch(
  () => router.currentRoute.value.params.eventId,
  async () => {
    await confStore.loadingPromise;
    const eventId = router.currentRoute.value.params.eventId;
    if (eventId) {
      if (!confStore.conferences.find((e) => e.conference_id == eventId)) {
        router.push({ name: "school-events" });
      }
    }
  }
);

onMounted(() => {
  watch(
    () => schoolStore.school_id,
    async () => {
      if (authStore.jwtData.authentication_type === "district") {
        confStore.conferences = [];
        confStore.archived_conferences = [];
        confStore.current_conferences = [];
        confStore.load();
        await confStore.loadingPromise;
        const eventId = router.currentRoute.value.params.eventId;
        if (eventId) {
          if (!confStore.conferences.find((e) => e.conference_id == eventId)) {
            router.push({ name: "school-events" });
          }
        }
      }
    }
  );
  watch([() => schoolStore.schoolDetails.data?.integration], async () => {
    if (
      authStore.jwtData.integration !== schoolStore.schoolDetails.data?.integration &&
      schoolStore.schoolDetails.data?.integration &&
      authStore.jwtData.integration
    ) {
      await authService.refresh();
    }
  });
});
</script>

<template>
  <v-app>
    <v-main class="custom-main">
      <LoadingUserData
        v-if="!Object.keys(authStore.me).length && $route.meta.requiresAuth"
      ></LoadingUserData>
      <RouterView v-else />
    </v-main>
  </v-app>
  <div class="toast-container">
    <Snackbar v-for="alert in alertStore.alerts" :index="alert.id" :key="alert.id" :alert="alert" />
  </div>
</template>

<style lang="scss">
.custom-main {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>
